/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetAnswerbookAskRequest = { question: string };

export const GetAnswerbookAskRequest$zodSchema: z.ZodType<
  GetAnswerbookAskRequest
> = z.object({
  question: z.string().describe("你想要提问的问题。问题不能为空。"),
});

/**
 * 服务器内部错误。
 */
export type GetAnswerbookAskInternalServerErrorResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
};

export const GetAnswerbookAskInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetAnswerbookAskInternalServerErrorResponseBody> = z.object({
    code: z.int().optional(),
    message: z.string().optional(),
  }).describe("服务器内部错误。");

/**
 * 请求参数无效。
 */
export type GetAnswerbookAskBadRequestResponseBody = {
  code?: number | undefined;
  message?: string | undefined;
};

export const GetAnswerbookAskBadRequestResponseBody$zodSchema: z.ZodType<
  GetAnswerbookAskBadRequestResponseBody
> = z.object({
  code: z.int().optional(),
  message: z.string().optional(),
}).describe("请求参数无效。");

/**
 * 成功获取答案。
 */
export type GetAnswerbookAskResponseBody = {
  question?: string | undefined;
  answer?: string | undefined;
};

export const GetAnswerbookAskResponseBody$zodSchema: z.ZodType<
  GetAnswerbookAskResponseBody
> = z.object({
  answer: z.string().optional(),
  question: z.string().optional(),
}).describe("成功获取答案。");

export type GetAnswerbookAskResponse =
  | GetAnswerbookAskResponseBody
  | GetAnswerbookAskBadRequestResponseBody
  | GetAnswerbookAskInternalServerErrorResponseBody;

export const GetAnswerbookAskResponse$zodSchema: z.ZodType<
  GetAnswerbookAskResponse
> = z.union([
  z.lazy(() => GetAnswerbookAskResponseBody$zodSchema),
  z.lazy(() => GetAnswerbookAskBadRequestResponseBody$zodSchema),
  z.lazy(() => GetAnswerbookAskInternalServerErrorResponseBody$zodSchema),
]);
